import React from "react";
import styled from "styled-components";
import { UIStyleConstants } from "../rule-engine-core/Common/UIStyleConstants";

const TextIconDiv = styled("div")<{
    height?: number;
    width?: number;
}>`
    font-size: 10px;
    border: 1px solid ${UIStyleConstants.BLUE_COLOR};
    border-radius: 5px;
    background: ${UIStyleConstants.WHITE_COLOR};
    color: ${UIStyleConstants.BLUE_COLOR};
    width: ${(props) => props.width || 24}px;
    height: ${(props) => props.height || 24}px;
    line-height: ${(props) => (props.height ? props.height - 2 : 22)}px;
    text-align: center;
    justify-content: center;
    align-content: center;
`;

export const TextIcon = function (props: { name: string; height?: number; width?: number }) {
    return (
        <TextIconDiv
            height={props.height}
            width={props.width}
        >
            {props.name}
        </TextIconDiv>
    );
};
